import Utils from './utils/Utils';

/**
 * Inter-Applications Communication
 * Communications engine used between windows
 */
class InterAppCom {
  constructor(name) {
    this.name = name;
    this.actions = {};
    this.setupStandards();
  }

  setupStandards() {
    window.addEventListener('message', ({ data }) => {
      let _data = {};
      try { _data = JSON.parse(data); } catch(e) { return; }
      for (let key in _data)
        if (this.actions[key])
          this.exec(key, _data[key]);
    });

    this.on('landbot-listen', () => console.log(`[${this.name}-LB] listener is active`));
  }

  /**
   * Set an action for an emitted event name
   * @param {String} eventName 
   * @param {Function} cb 
   */
  on(eventName, cb) {
    const _cb = cb || new Function();
    if (this.actions[eventName])
      this.actions[eventName].push(_cb);
    else
      this.actions[eventName] = [_cb];
  }

  /**
   * Removes a listener for given event name
   * @param {String} eventName 
   */
  off(eventName, cb) {
    if (this.actions[eventName] && cb) {
      const index = this.actions[eventName].indexOf(cb);
      if (index > -1)
        this.actions[eventName].splice(index, 1);
    } else
      delete this.actions[eventName];
  }

  /**
   * Emits an action with given data
   * @param {String} eventName 
   * @param {Object} data 
   */
  exec(eventName, data = true) {
    if (this.actions[eventName]) {
      for (let i = 0; i < this.actions[eventName].length; i++)
        this.actions[eventName][i](data);
    }
  }

  /**
   * message: { eventName: data }
   */
  send(channel, data = true) {
    const _message = Object.assign(
      { [channel]: data },
      { name: this.name }
    );
    parent.postMessage(JSON.stringify(_message), Utils.getOrigin() || '*');
  }
}

export default InterAppCom;


// WEBPACK FOOTER //
// ../UmiCore/src/InterAppCom.js